//@flow
import * as actionTypes from './actionTypes';
import {
    getDemeterVendorsApi,getDemeterStoreLocationsApi,getDemeterItemsApi,
    createDemeterItemApi,updateDemeterItemApi,moveDownDemeterItemApi,
    moveUpDemeterItemApi,deleteDemeterItemApi,submitTaskApi,getDemeterTaskApi
} from '../../apiUtils/api';
import type { Dispatch,ReducerState$Type,PostPayloadData } from './flowTypes'
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from './submitFormData'

export const getTaskData=(demeter:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch) => getDemeterTaskApi(jwt,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.DEMETER_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,demeter)
            dispatch({
                type: actionTypes.DEMETER_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DEMETER_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const openAddInvItemForm=()=>{
    return { type: actionTypes.OPEN_ADD_INV_ITEM_FORM };
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.DEMETER_INV_SUBMITTED_COMPLETED };
}

export const cancelAddInvItemForm=()=>{
    return { type: actionTypes.CANCEL_ADD_INV_ITEM_FORM };
}

export const populateVendorsList=(jwt:any,compIdCode:string)=>{
    return (dispatch:Dispatch) => getDemeterVendorsApi(jwt,compIdCode).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_DEMETER_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_DEMETER_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_DEMETER_VENDORS_ERROR, error: err});
    })
}

export const populateStoreLocationsList=(jwt:any,compIdCode:string)=>{
    return (dispatch:Dispatch) => getDemeterStoreLocationsApi(jwt,compIdCode).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_SUCCESS, storeLocations: data.storeLocations });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_DEMETER_STORE_LOCATIONS_ERROR, error: err});
    })
}

export const getDemeterItems=(jwt:any,page:number,pageSize:number,sortField:string,sortOrder:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch) => getDemeterItemsApi(jwt,page.toString(),pageSize.toString(),sortField,sortOrder,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_DEMETER_ITEMS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_DEMETER_ITEMS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_DEMETER_ITEMS_ERROR,error: err});
    })
}

export const setPage=(jwt:any,demeter:ReducerState$Type,page:number)=>{
    return getDemeterItems(jwt,page,(demeter.pageSize:any),(demeter.sortField:any),demeter.sortOrder,(demeter.taskAcceptedInfoId:any));
}

export const setPageSize=(jwt:any,demeter:ReducerState$Type,pageSize:number)=>{
    return getDemeterItems(jwt,(demeter.page:any),pageSize,(demeter.sortField:any),demeter.sortOrder,(demeter.taskAcceptedInfoId:any));
}

export const sortData=(jwt:any,demeter:ReducerState$Type,sortField:any,sortOrder:any)=>{
    return getDemeterItems(jwt,(demeter.page:any),(demeter.pageSize:any),sortField,sortOrder,(demeter.taskAcceptedInfoId:any));
}

export const createNewDemeterItem=(jwt:any,newDemeterItem:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch) => createDemeterItemApi(jwt,newDemeterItem,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.CREATE_NEW_DEMETER_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.CREATE_NEW_DEMETER_ITEM_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.CREATE_NEW_DEMETER_ITEM_ERROR,error: err});
    })
}

export const editDemeterItem=(demeterItem:any)=>{
    let convertToFormObj={};
    convertToFormObj.id=demeterItem.id;
    convertToFormObj.itemDesc=demeterItem.item_desc;
    convertToFormObj.itemQty=demeterItem.item_qty;
    convertToFormObj.itemPrice=demeterItem.item_price;
    convertToFormObj.itemTotal=demeterItem.item_total;
    convertToFormObj.isOverrideItemTotal=demeterItem.is_override_item_total;
    convertToFormObj.isOverrideNaItemQty=demeterItem.is_override_na_item_qty;
    convertToFormObj.isOverrideNaItemPrice=demeterItem.is_override_na_item_price;
    
    return { type: actionTypes.EDIT_DEMETER_ITEM, demeterItem: convertToFormObj };
}

export const updateDemeterItem=(jwt:any,updateDemeterItem:any,id:number)=>{
    return (dispatch:Dispatch) => updateDemeterItemApi(jwt,updateDemeterItem,id.toString())
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_DEMETER_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATE_DEMETER_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_DEMETER_ITEM_ERROR,error: err});
    })
}

export const moveDownDemeterItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch) => moveDownDemeterItemApi(jwt,id.toString())
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_DOWN_DEMETER_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_DOWN_DEMETER_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_DOWN_DEMETER_ITEM_ERROR,error: err});
    })
}

export const moveUpDemeterItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch) => moveUpDemeterItemApi(jwt,id.toString())
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_UP_DEMETER_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_UP_DEMETER_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_UP_DEMETER_ITEM_ERROR,error: err});
    })
}

export const deleteDemeterItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch) => deleteDemeterItemApi(jwt,id.toString())
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.DELETE_DEMETER_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.DELETE_DEMETER_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DELETE_DEMETER_ITEM_ERROR,error: err});
    })
}

export const selectDemeterItemId=(id:number)=>{
    return { type: actionTypes.SELECTED_DEMETER_ITEM_ID, id};
}

export const refreshDemeterItem=(demeterItem:any)=>{
    return { type: actionTypes.REFRESH_DEMETER_ITEM, demeterItem: demeterItem};
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,demeterHeader:any,demeter:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (demeterHeader.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorIdCode=demeterHeader.vendorIdCode;
        payload.storeIdCode=demeterHeader.storeIdCode;
        payload.isOverrideVendorName=demeterHeader.isOverrideVendorName?demeterHeader.isOverrideVendorName:false;
        payload.isOverrideShipTo=demeterHeader.isOverrideShipTo?demeterHeader.isOverrideShipTo:false;
        payload.invNo=demeterHeader.invNo;
        payload.invDate=demeterHeader.invDate;
        payload.invTotal=demeterHeader.invoiceTotal;
        payload.isOverrideInvTotal=demeterHeader.isOverrideInvTotal?demeterHeader.isOverrideInvTotal:false;
        payload.isInvalidDoc=demeterHeader.isInvalidDoc?demeterHeader.isInvalidDoc:false;
        payload.poNo=demeterHeader.poNo?demeterHeader.poNo:'';
        
        payload.approvalCode=demeterHeader.approvalCode;
    
        if (payload.isOverrideVendorName===true){
            payload.vendorIdCode='';
            payload.vendorName=demeterHeader.vendorName;
        }else {
            if (demeter.vendors){
                const vendor = demeter.vendors.find((v)=>v.vendor_id_code==payload.vendorIdCode)
                payload.vendorName=vendor?vendor['vendor_name']:''
            }
        }
    
        if (payload.isOverrideShipTo===true){
            payload.storeIdCode='';
            payload.shipToAddr=demeterHeader.shipToAddr;
        }else {
            if (demeter.storeLocations){
                const storeLoc = demeter.storeLocations.find((v)=>v.store_id_code==payload.storeIdCode)
                payload.shipToAddr=storeLoc?storeLoc.ship_to:'';
            }
        }
    }

    if (demeter.reviewQuestions && demeter.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(demeterHeader,demeter.reviewQuestions)
    }
    
    return (dispatch:Dispatch) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.DEMETER_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.DEMETER_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DEMETER_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.DEMETER_UPDATE_FORM_ERROR, formError: error }
}


// WEBPACK FOOTER //
// ./src/redux/demeter/actions.js